import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ValueList from "@/modules/recognition/admin/components/ValueList";
import { fetchValuesQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/values/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "recognition.recognition-value.view");

    return {
      crumb: [
        {
          label: context.t("Values", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchValuesQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("recognition.admin");
  return (
    <Container
      title={t("Management of appreciation criteria")}
      description={t("Manage, create, or edit appreciation criteria.")}
    >
      <ValueList />
    </Container>
  );
}
